module.exports = __webpack_public_path__ + "assets/images/open-outline.860ae3d341a897aa6049350297770050.svg";